import React from 'react';

export default function PopularGames() {
  return (
    <>
    
    </>
  );
}
